module.exports = __webpack_public_path__ + "img/invite_other.25572ca4.svg";